import React, { useState } from 'react';

const PasswordStrength = () => {
    const [password, setPassword] = useState('');
    const [strengthMessage, setStrengthMessage] = useState('');

    const checkPasswordStrength = (password) => {
        if (password.length < 6) {
            return 'Weak password';
        } else if (/\d/.test(password)) {
            return 'Strong password';
        } else {
            return 'Moderate password';
        }

    };

    const handleChange = (e) => {
        const newPassword = e.target.value;
        setPassword(newPassword);
        setStrengthMessage(checkPasswordStrength(newPassword));
    };

    // CSS styles defined as objects
  const strengthStyles = {
    weakMessage: {
      color: 'red',
    },
    moderateMessage: {
        color: 'orange',
    },
    strongMessage: {
      color: 'green',
    },
    strengthMessage: {
      marginTop: '10px',
    },
  };

    return (
        <div style={{ textAlign: 'center', marginTop: '50px', padding: '20px' }}>
            <h2 className="card-title" style={{ marginBottom: '10px' }}>Password Strength Checker</h2>
            <p className="card-text" style={{ marginBottom: '10px' }}>Enter your password to check its strength<br />
            For best results, password should be 6 or more characters and contain a number</p>

            <input
                type="password"
                value={password}
                onChange={handleChange}
                placeholder="Enter your password"
                style={{ display: 'block', margin: '10px auto' }}
            />
            {strengthMessage ? (
        <p className="card-text" style={{ 
          ...strengthStyles.strengthMessage, 
          ...(strengthMessage === 'Weak password' ? strengthStyles.weakMessage : 
            strengthMessage === 'Strong password' ? strengthStyles.strongMessage :
            strengthStyles.moderateMessage) 
        }}>
      {strengthMessage}</p>
      ) : ( 
      <p className="card-text" style={{ ...strengthStyles.strengthMessage }}><br /></p> )}
        </div>
    );
};

export default PasswordStrength;
